// extracted by mini-css-extract-plugin
export default {"container":"videoSection_container__ojxpn","videoCon":"videoSection_videoCon__jXKMY","video":"videoSection_video__0C6gE"};